export default {
  stages: [],
  stage: undefined,
};
